'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'tire-rugged';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f634';
var svgPathData = 'M296 0c13.3 0 24 10.7 24 24l0 17.3c14.9 4.4 29.1 10.4 42.6 17.6l12.2-12.2c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9l-12.2 12.2c7.3 13.4 13.2 27.7 17.6 42.6l17.3 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-17.3 0c-4.4 14.9-10.4 29.1-17.6 42.6l12.2 12.2c9.4 9.4 9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0l-12.2-12.2c-13.4 7.3-27.7 13.2-42.6 17.6l0 17.3c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-17.3c-14.9-4.4-29.1-10.4-42.6-17.6l-12.2 12.2c-9.4 9.4-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9l12.2-12.2c-7.3-13.4-13.2-27.7-17.6-42.6L24 320c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l17.3 0c4.4-14.9 10.4-29.1 17.6-42.6L46.7 137.2c-9.4-9.4-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0l12.2 12.2c13.4-7.3 27.7-13.2 42.6-17.6L192 24c0-13.3 10.7-24 24-24l80 0zm88 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM232 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-64 64a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-88-88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTireRugged = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;